const nl = {
    'actions': {
        'add': 'Toevoegen',
        'addaccount': 'Account aanvragen',
        'back': 'Terug',
        'backtoadmin': 'Terug naar beheer',
        'createuser': 'Maak gebruiker',
        'close': 'Sluiten',
        'delete': 'Verwijderen',
        'download': 'Downloaden',
        'edit': 'Bewerken',
        'export': 'Exporteren',
        'impersonate': 'Inloggen&nbsp;als',
        'sendinvite': 'Uitnodiging&nbsp;sturen',
        'login': 'Inloggen',
        'logout': 'Uitloggen',
        'next': 'Volgende',
        'previous': 'Vorige',
        'ok': 'Ok',
        'save': 'Opslaan',
        'search': 'Zoeken',
        'submit': 'Versturen',
        'returntologin': 'Terug naar login',
        'resetuser': 'Uitnodiging sturen'
    },
    'confirm': {
        'leaveWithoutSave': '<strong>Weet u zeker dat u deze pagina wilt verlaten?</strong><br />Er zijn wijzigingen die nog niet zijn opgeslagen',
        'delete': '<strong>Weet u het zeker?</strong><br />De gegevens worden definitief verwijderd',
        'changerole': '<strong>Weet u het zeker?</strong><br />De rol van deze gebruiker wordt gewijzigd',
        'archive': '<strong>Weet u het zeker?</strong><br />De gegevens worden gearchiveerd',
    },
    'error': {
        'saveChanges': 'Er is een probleem opgetreden tijdens het opslaan van de gegevens',
        'deleteRecordConflict': 'Dit record kan niet worden verwijderd',
        'emailexists': 'Dit e-mailadres is al in gebruik',
        'emailnotfound': 'E-mail niet gevonden. Neem contact op met Telefoonaanname',
        'exporttoexcel': 'Fout tijdens het exporteren van bestand',
        'fetch': 'Fout terwijl u gegevens ophaalt',
    },
    'format': {
        'dateo': 'D MMMM YYYY',
        'date': 'dd D MMMM YYYY',
        'dateTime': 'dd D MMMM YYYY HH:mm',
        'fullDate': 'LLLL',
        'time': 'HH:mm',
        'timezone': 'UTC'
    },
    'salutation': {
        'M': 'De heer',
        'F': 'Mevrouw',
        'V': 'Mevrouw'
    },
    'gen': {
        'M': 'Man',
        'F': 'Vrouw',
        'V': 'Vrouw'
    },
    'intervalType': {
        'daily': 'Dagelijks',
        'weekly': 'Wekelijks',
        'twoWeekEven': 'Tweewekelijks ( even weken )',
        'twoWeekOdd':'Tweewekelijks ( oneven weken )'
    },
    'path': {
        'alert': '/alert',
        'home': '/',
        'login': '/login',
        'forgotpassword': '/login/wachtwoordvergeten',
        'setpassword': '/wijzigwachtwoord',
        'companies': '/relatie',
        'feedback': '/feedback',
        'workers': 'medewerkers',
        'message': '/berichten',
        'invoice': '/factuur',
        'staffmembers': '/personeel',
        'staffmembersExport': '/export',
        'worker': '/medewerker',
        'workerinstruction': '/werkinstructie',
        'workercompany': '/werkmaatschappij',
        'workeralert': '/alertmedewerker',
        'log': '/logboek',
        'manage_administrator': '/beheren/beheerder',
        'validateaccount': '/aanmelden',
        'manage_unemployementhistory': '/uitdienstgeschiedenis',
        'workerparttime': '/partimedag',
        'enum':'/beheren/opties',
    },
    'periods': {
        'short': {
            'sunday': 'Zo',
            'monday': 'Ma',
            'tuesday': 'Di',
            'wednesday': 'Wo',
            'thursday': 'Do',
            'friday': 'Vr',
            'saturday': 'Za',
            'january': 'Jan',
            'february': 'Feb',
            'march': 'Maa',
            'april': 'Apr',
            'may': 'Mei',
            'june': 'Jun',
            'july': 'Jul',
            'august': 'Aug',
            'september': 'Sep',
            'october': 'Okt',
            'november': 'Nov',
            'december': 'Dec',
        },
        'long': {
            'january': 'Januari',
            'february': 'Februari',
            'march': 'Maart',
            'april': 'April',
            'may': 'Mei',
            'june': 'Juni',
            'july': 'Juli',
            'august': 'Augustus',
            'september': 'September',
            'october': 'Oktober',
            'november': 'November',
            'december': 'December',
            'sunday': 'Zondag',
            'monday': 'Maandag',
            'tuesday': 'Dinsdag',
            'wednesday': 'Woensdag',
            'thursday': 'Donderdag',
            'friday': 'Vrijdag',
            'saturday': 'Zaterdag',
        },
        'week': 'Week',
        'month': 'Maand'
    },
    'status': {
        'status': 'Status',
        'loading': 'Laden...',
        'norecords': 'Geen gegevens gevonden',
        'loginfailed': 'Ongeldige combinatie van e-mailadres en wachtwoord',
        'invalidpassword': 'Het wachtwoord is ongeldig',
        'tokenexpired': 'Uw token voor het opnieuw instellen van uw wachtwoord is verlopen',
    },
    'success': {
        'saveChanges': 'De gegevens zijn succesvol opgeslagen',
        'deleteRecord': 'De gegevens zijn succesvol verwijderd',
        'updatepassword': 'Uw wachtwoord is ingesteld. U kunt nu inloggen',
        'resetpassword': 'Reset wachtwoordlink verzonden naar uw e-mailadres!',
        'sentmail': 'Mail succesvol verzonden!',
        'forgotpassword': 'U ontvangt binnen enkele minuten een e-mail met enn link om een nieuw wachtwoord in te stellen.',
        'usercreated': 'Account succesvol aangemaakt'
    },
    'subtitle': {
        'forgotpassword': 'Voer hier uw e-mailadres in. U ontvangt daarna een e-mail om een nieuw wachtwoord in te stellen.'
    },
    'title': {
        'administrator': 'Beheerders',
        'alert': 'Alert',
        'home': 'Home',
        'portal': 'Klantenportaal',
        'setpassword': 'Stel een wachtwoord in',
        'updatepassword': 'Wijzig wachtwoord',
        'testenvironment': 'TESTVERSIE',
        'feedback': 'Feedback',
        'profile': 'Profiel',
        'login': 'Login',
        'emailsent': 'E-Mail VERZONDEN',
        'companies': 'Relaties',
        'companiesmenu': 'Bedrijfsaccount',
        'workers': 'Medewerkers',
        'workerparttime': 'Parttimedag',
        'message': 'Berichten',
        'mymessage': 'Mijn berichten',
        'allmessage': 'Alle berichten',
        'invoice': 'Facturen',
        'worker': 'Medewerker',
        'workerinstruction': 'Afwezigheid doorgeven',        
        'companyinstruction': 'Bedrijfsinstructie',
        'termination': 'Medewerker verwijderen of uit dienst melden',
        'log': 'Logboek',
        'createaccount': 'Voer hier uw e-mailadres in. Indien uw gegevens bij ons bekend zijn, ontvangt u een e-mail waarmee u een wachtwoord kunt aanmaken.',
        'unemploymenthistory': 'Uit dienst log',
        'enums': 'Instellingen',
        'myaccount':'Mijnaccount',
    },
    'form': {
        'profile': 'Profiel bewerken',
    },
    'warnings': {

    },
    'access': 'Toegang',
    'active': 'Actief',
    'account': 'Account',
    'accounts': 'Gebruikers zonder account',
    'additionaldata': 'Aanvullende gegevens',
    'address': 'Adres',
    'all': 'Alle',
    'alert': 'Alert',
    'alertdescription': 'Van de box \'Alert\' maakt u geen actief gebruik. Deze wordt door telefoonaanname.nl gebruikt als er sprake is van een spoedeisende calamiteit waardoor wij onze diensten niet kunnen uitvoeren, zoals bijvoorbeeld een stroom- of internetstoring. Alle klanten kunnen dan in één keer gewaarschuwd worden.',
    'amount': 'Bedrag',
    'archived': 'Gearchiveerd',
    'administrator': 'Beheerder',
    'and': 'en',
    'banknumber': 'Banknummer',
    'blocked': 'Geblokkeerd',
    'buycredits': 'Vacaturebundel',
    'changepassword': 'Wachtwoord wijzigen',
    'city': 'Plaats',
    'company': 'Relatie',
    'companydetail': 'Bedrijfsdetail',
    'code': 'Code',
    'confirmpassword': 'Bevestig wachtwoord',
    'content': 'Inhoud',
    'country': 'Land',
    'currentpassword': 'Huidig wachtwoord',
    'day': 'Dag | Dagen',
    'date': 'Datum',
    'dateoftermination': 'Datum van beëindiging',
    'companyactivity': 'Bedrijfsactiviteit',
    'description': 'Omschrijving',
    'dateofbirth': 'Geboortedatum',
    'dateexpiration': 'Vervaldatum',
    'datestartinstru': 'Startafwezigheid',
    'datestart': 'Startdatum',
    'dateend': 'Einddatum',
    'dateendinstru': 'Weerterug',
    'deleted': 'Verwijderd',
    'download': 'Download',
    'downloadfile': 'Downloadbestand',
    'email': 'E-mail',
    'emailaddress': 'E-mailadres',
    'externalid': 'ExterneId',
    'exportmessage': 'Berichtenexporteren',
    'feedbackinstruction': 'Heeft u vragen of opmerkingen over ons klantenportaal? Laat het ons dan weten via onderstaand formulier.',
    'feedback': 'Feedback',
    'feedbacklabel':'Versturen',
    'firstname': 'Voornaam',
    'forgotpassword': 'Wachtwoord vergeten?',
    'from': 'Van',
    'function': 'Functie',
    'gender': 'Geslacht',
    'general': 'Algemeen',
    'iban': 'IBAN',
    'initials': 'Voorletters',
    'inbox': 'Postvak IN',
    'invoice': 'Facturen',
    'invoiceno': 'Factuurnr.',
    'isarchived': 'Is gearchiveerd',
    'instructions': 'Afwezigheid doorgeven',
    'instructionsmain': 'Uw status is opgeslagen als niet bereikbaar tot het einde van de dag.',
    'instructionssub': 'AANVULLENDE INSTRUCTIES',
    'intervalTypelabel':'Interval',
    'language': 'Taal',
    'lastname': 'Achternaam',
    'lastchangeexternal': 'Laatste wijziging extern',
    'labeltitle': 'Titel',
    'log': 'Logboek',
    'markasunread': 'Markeren als ongelezen',
    'middlename': 'Tussenvoegsel',
    'messagesms': 'SMS Hier zijn extra kosten aan verbonden; (maximaal 160 tekens per bericht).',
    'messageapp': 'App',
    'messageemail': 'E-Mail',
    'messages': 'Berichten',
    'messageparttime':'Boodschap aan telefoniste',
    'month': 'Maand|Maanden',
    'mobile': 'Mobielnummer',
    'moredetail': 'Meer details',
    'name': 'Naam',
    'newpassword': 'Nieuw wachtwoord',
    'no': 'Nee',
    'none': 'Geen',
    'number': 'Nummer',
    'option': 'Optie',
    'optional': '(OPTIONEEL)',
    'enums': 'Instellingen',
    'organization': 'Organisatie',
    'quantity':'Aantal',
    'password': 'Wachtwoord',
    'passwordRequirements': 'Het wachtwoord dient minimaal 6 tekens lang te zijn en minimaal: 1 hoofdletter, 1 kleine letter, 1 getal en een speciaal teken (b.v. ! @ # $ % ^ & * _ -) te bevatten.',
    'payment': 'Betaling',
    'paymenttype': 'Betalingswijze',
    'pdf': 'PDF',
    'phone': 'Telefoon',
    'phoneforwardingnumber': 'Doorverbindnummer',
    'postaladdress': 'Postadres',
    'postalcode': 'Postcode',
    'public': 'openbaar',
    'purposeofleaveenum':'Toelichting',
    'recipient': 'Ontvanger',
    'remarks': 'Opmerkingen',
    'reference': 'Referentie',
    'referencecustomer': 'Referentieklant',
    'receivemessagevia': 'Berichten ontvangen via',
    'reasonofabsence':'Valluik reden afwezigheid',
    'sendinvitation': 'Stuur uitnodigingsmail',
    'sendpassword': 'Verstuur e-mail',
    'sendercompany': 'Afzender bedrijf',
    'senderemail': 'E-mailadres',
    'senderphone': 'Telefoon',
    'senderaddress': 'Zender adres',
    'sendername': 'Naam afzender',
    'setpassword': 'Stel een wachtwoord in',
    'settings': 'Instellingen',
    'setupaccount': 'ACCOUNT INSTELLEN',
    'subtotal': 'Subtotaal',
    'staffmembers': 'Medewerkers',
    'workerinstruction': 'Afwezigheid Doorgeven',
    'workerdetail': 'Account',
    'street': 'Straat',
    'streetnumber': 'Huisnummer',
    'starttime': 'Starttijd',
    'endtime': 'Eindtijd',
    'telephone1': 'Telefoonnummer privé',
    'telephone2': 'Telefoonnummer mobiel',
    'total': 'Totaal',
    'totalexlvat': 'Totaal excl. BTW',
    'totalinclvat': 'Totaal',
    'totalvat': 'BTW',
    'type': 'Soort',
    'to': 'Aan',
    'terminationdescription': 'Geef hier de datum uitdiensttreding op. De medewerker zal uit het klantenportaal worden verwijderd als de opgegeven datum is verstreken.',
    'unemploymenthistory': 'Uit dienst log',
    'upto': 't/m',
    'uptoandincluding': 'Tot en met',
    'username': 'E-mailadres',
    'user': 'Gebruiker',
    'vatnumber': 'BTWnummer',
    'view': 'Weergave',
    'visitingaddress': 'Bezoekadres',
    'warning': 'Waarschuwing',
    'website': 'Website',
    'workers': 'Gebruikers',
    'worker': 'Medewerkers',    
    'workerparttime': 'Mijn Parttime dag',
    'workerinstructionmessage': 'Vul hier een eventuele reden van afwezigheid in',
    'companyinstruction': 'Bedrijfsinstructie',
    'year': 'Jaar',
    'yes': 'Ja',
    'zipcode': 'Postcode',
    'WorkerAdmin': 'Beheerder',
    'WorkerUser': 'Gebruiker',
    'role': 'Rol',
    'count': 'Aantal'
};

export default nl;